import React from "react";

export default function OurStory() {
  return (
    <div className="min-h-screen bg-gray-50 py-24 px-4 sm:px-6 lg:px-8 sm:py-32 lg:py-40">
      <div className="max-w-7xl mx-auto">
        {/* Badge */}
        <div className="mb-8">
          <span className="inline-block bg-blue-100 text-blue-600 px-6 py-2 rounded-full text-sm font-medium">
            OUR STORY
          </span>
        </div>

        {/* Main Content Grid */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          {/* Left Column - Text Content */}
          <div className="space-y-6">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              From Vision to Reality
            </h1>

            <div className="space-y-6 text-gray-600 text-base sm:text-lg leading-relaxed">
              <p>
                Founded in 2016 by a team of passionate technologists, Postmint
                began with a simple yet powerful vision: to bridge the gap
                between cutting-edge technology and business success.
              </p>

              <p>
                What started as a small team of developers and designers has
                grown into a comprehensive IT solutions provider, serving
                clients across various industries and helping them navigate the
                digital transformation landscape.
              </p>

              <p>
                Today, we continue to push boundaries, embrace emerging
                technologies, and deliver solutions that not only meet current
                needs but anticipate future challenges.
              </p>
            </div>

            {/* Features */}
            <div className="flex flex-wrap gap-6 pt-4">
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                <span className="text-gray-700 font-medium">
                  Innovation-First Approach
                </span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                <span className="text-gray-700 font-medium">
                  Client Success Focus
                </span>
              </div>
            </div>
          </div>

          {/* Right Column - Image with Badge */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=600&fit=crop"
                alt="Team collaboration"
                className="w-full h-auto object-cover"
              />
            </div>

            {/* Years Badge - Positioned over image */}
            <div className="absolute bottom-0 -left-4 sm:-left-6 lg:-left-8 transform translate-y-1/2 bg-blue-500 text-white rounded-2xl shadow-lg px-8 py-6 text-center">
              <div className="text-4xl font-bold">2+</div>
              <div className="text-sm font-medium mt-1">Years</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
